/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_SelectionInputs */

const en_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme Selection`)
};

const fr_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection du thème`)
};

const de_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themenauswahl`)
};

const it_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione del tema`)
};

const ru_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор темы`)
};

const es_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de temas`)
};

const zh_cn2_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题选择`)
};

const ja_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマの選択`)
};

const hi_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय चयन`)
};

const pt_pt2_theme_selection = /** @type {(inputs: Theme_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção do tema`)
};

/**
* | output |
* | --- |
* | "Theme Selection" |
*
* @param {Theme_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const theme_selection = /** @type {((inputs?: Theme_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_theme_selection(inputs)
	if (locale === "de") return de_theme_selection(inputs)
	if (locale === "it") return it_theme_selection(inputs)
	if (locale === "ru") return ru_theme_selection(inputs)
	if (locale === "es") return es_theme_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_theme_selection(inputs)
	if (locale === "ja") return ja_theme_selection(inputs)
	if (locale === "hi") return hi_theme_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_theme_selection(inputs)
	return en_theme_selection(inputs)
});